/**
 * Mirrors backend SubscriptionTierContract (Subscriptions/Api/Contracts).
 * Solo is the classic instructor product (founding rate applies); Verein adds
 * the member-portal community features and bills at the regular rate.
 */
export enum SubscriptionTier {
  Solo = "Solo",
  Verein = "Verein",
}
